__turbopack_context__.v({
  "grid": "PressureCards-module__tdtofq__grid",
  "item": "PressureCards-module__tdtofq__item",
  "wrap": "PressureCards-module__tdtofq__wrap",
});
